import { Link } from "react-router-dom";
import {
  Box,
  Button,
  List,
  ListItem,
  Typography,
  useTheme,
} from "@mui/material";

import useResponsive from "@/hooks/useResponsive";
import {
  detailsStyles,
  getListItemStyles,
  imageWrapperStyles,
} from "../styles";
import AnimatedImage from "@/components/UI-Kit/AnimatedImage";

interface IProps {
  trackmateData: ITrackmateCard;
}
const StepperContentCard: React.FC<IProps> = ({ trackmateData }) => {
  const { imageUrl, thumbnail, title, details, description, button } =
    trackmateData;
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();

  return (
    <Box textAlign={{ xs: "center", md: "start" }} maxWidth={530}>
      <Typography
        variant="h6"
        color="text.primary"
        fontSize={"1.5rem !important"}
        mb={{ xs: 3, md: 4 }}
      >
        {title}
      </Typography>
      <List disablePadding sx={detailsStyles}>
        {details.map((value, index) => (
          <ListItem key={index} disablePadding sx={getListItemStyles(theme)}>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              fontSize={{ xs: "1rem", md: "1.25rem" }}
              textAlign={{ xs: "center", md: "start" }}
            >
              {value}
            </Typography>
          </ListItem>
        ))}
      </List>

      {/* If there is a path - router link to go to the specified route, otherwise - button  */}
      {button.path ? (
        <Button
          component={Link}
          to={button.path}
          variant="contained"
          sx={{ width: 222, mb: { xs: 2, md: 3 } }}
        >
          {button.title}
        </Button>
      ) : (
        <Button
          variant="contained"
          sx={{ width: 222, mb: { xs: 2, md: 3 } }}
          onClick={() => console.log("download app")}
        >
          {button.title}
        </Button>
      )}

      <Typography
        variant="body1"
        color="text.secondary"
        fontSize={{ sm: 16 }}
        mb={{ xs: 3, md: 0 }}
        maxWidth={{ md: 390 }}
      >
        {description}
      </Typography>

      {isMobile && (
        <AnimatedImage
          sx={imageWrapperStyles}
          thumbnailUrl={thumbnail}
          mainUrl={imageUrl}
          alt={title}
        />
      )}
    </Box>
  );
};

export default StepperContentCard;
